import React from 'react'
import { Input } from 'antd'
import { applyUnitSearch } from '../../../store/actionsCreators/unitsActions'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'
import { type RootState } from '../../../store/store'
import { setMyArchivedUnitsOpen, setMyFavoritesUnitsOpen, setMyPublishedUnitsOpen, setMyRequestedUnitsOpen, setPublishedVisibilityFilter, setUnitsCategory, unitsSlice } from '../../../store/slices/unitsSlice'
import useFireSearch from '../../../hooks/useFireSearch'
import Icon from '../../../app/icon/Icon'
import { Link } from 'react-router-dom'
import UseUserType from '../../../hooks/UseUserType'
import { REACT_APP_BSO_USER_ID, USER_ID_KEY } from '../../../urls'
import { getDynamicSize } from '../../../functions/adapters/getDynamicSize'
import { buildMyUnitsContextCounts, buildMyUnitsListingCounts } from '../../../functions/shared/units/unitVisibility'

export default function UnitsHeaderSh(): JSX.Element {
    // const { Search } = Input
    const { userType, userTypeLowercase } = UseUserType()
    const currentUser = useAppSelector((state: RootState) => state.user.currentUser)
    const userID = window.localStorage.getItem(USER_ID_KEY) ?? currentUser.id ?? ''

    const dispatch = useAppDispatch()
    const { searchString, units } = useAppSelector((state: RootState) => state.units)
    const { myArchivedUnitsOpen, myFavoritesUnitsOpen, myRequestedUnitsOpen, myPublishedUnitsOpen } = useAppSelector((state) => state.units)
    const contextCounts = React.useMemo(() => buildMyUnitsContextCounts(units), [units])
    const archiveCount = contextCounts.bsoArchived
    const requestedCount = contextCounts.externalRequested
    const otherUnitsCount = contextCounts.externalCatalogVisible + contextCounts.externalOperationalOnly
    const externalContextOpen = myRequestedUnitsOpen || myPublishedUnitsOpen
    const listingCounts = React.useMemo(() => buildMyUnitsListingCounts(units), [units])

    // console.log(myFavoritesUnitsOpen, "myFavoritesUnitsOpen")
    /* useFireSearch({
        callback: () => {
            dispatch(applyUnitSearch())
        },
        delay: 300,
        controlValue: searchString
    }) */


    function Searc2h(): JSX.Element {
        return (
            <span className="">
                {/* <i className="bi bi-search fs-3 me-2 p-0 "></i> */}
                <Icon
                    name={'search'}
                    className={'text-muted fs-3 me-2 p-0'}
                />
            </span>
        )
    }

    return (

        <div className=" w-100 g-0 pb-2">
            {Number(userID) === Number(REACT_APP_BSO_USER_ID) && (
                <section className={`my-units-context card card-flush my-units-context--${externalContextOpen ? 'external' : 'bso'}`} aria-label="Unit workspace context">
                    <div className="my-units-context__title card-title m-0">
                        <span className="badge badge-light-primary my-units-context__badge">{externalContextOpen ? 'EXTERNAL UNITS' : 'BSO LISTINGS'}</span>
                        <div>
                            <strong>{externalContextOpen ? 'External units' : 'BSO Portfolio'}</strong>
                            <small>{externalContextOpen ? 'Requests and other active listings' : 'BSO rental and sale listings'}</small>
                        </div>
                    </div>
                    {externalContextOpen
                        ? <div className="my-units-context__metrics" aria-label="External unit counts">
                            <span><b>{contextCounts.externalRequested}</b> requested</span>
                            <span><b>{otherUnitsCount}</b> other units</span>
                            <span><b>{contextCounts.externalCatalogVisible}</b> catalog visible</span>
                            <span><b>{contextCounts.externalOperationalOnly}</b> operational only</span>
                            <span><b>{listingCounts.externalRentals}</b> rentals</span>
                            <span><b>{listingCounts.externalSales}</b> sales</span>
                        </div>
                        : <div className="my-units-context__metrics" aria-label="BSO unit counts">
                            <span><b>{contextCounts.bsoTotal}</b> total BSO</span>
                            <span><b>{contextCounts.bsoCatalogVisible}</b> catalog visible</span>
                            <span><b>{contextCounts.bsoArchived}</b> archived</span>
                            <span><b>{listingCounts.bsoRentals}</b> rentals</span>
                            <span><b>{listingCounts.bsoSales}</b> sales</span>
                        </div>}
                </section>
            )}
            <div className="d-flex flex-row mt-4 w-100">
                <div className={`w-100`}>
                    {/* col-${process.env.REACT_APP_IS_DEV === 'true' || Number(userID) === Number(REACT_APP_BSO_USER_ID) ? '8' : '12'} */}
                    <Input
                        className={''}
                        allowClear
                        placeholder='Search unit'
                        value={searchString}
                        onChange={(e: any) => {
                            dispatch(unitsSlice.actions.unitsSetSearchString(e.target.value))
                        }}
                        // onKeyPress={(e: any) => {
                        // if (e.key === 'Enter') {
                        // dispatch(applyUnitSearch())
                        // }
                        // }}
                        prefix={<Searc2h />}
                    />
                </div>
                {userType === 'Agent'
                    ? process.env.REACT_APP_IS_DEV === 'true'
                        ? <div className="d-flex justify-content-between w-auto">
                            <div className=" w-auto">
                                <Link className="text-decoration-none" to={'/agent/my_units'}>
                                    <div className="btn btn-bg-light-secondary p-2 px-auto ms-3 border border-dark link-dark fw-bold fs-7 text-uppercase text-nowrap "
                                        style={{ width: "calc(90%)" }}>
                                        My Units
                                    </div>
                                </Link>
                            </div>
                            <div className="">
                                <div className="btn btn-bg-light-secondary min-h-30px max-h-30px p-1 ps-2 ms-2 border border-dark link-dark fw-bold fs-7 text-uppercase text-nowrap w-auto"
                                    //   min-w-30px max-w-30px
                                    onClick={
                                        () => {
                                            dispatch(setMyFavoritesUnitsOpen(!myFavoritesUnitsOpen));
                                        }
                                    }>
                                    <i className={`ki-duotone ki-heart-circle fs-2x ${myFavoritesUnitsOpen ? 'text-dark' : ""}`}>
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                    {/* {getDynamicSize().showFavorites && "Favorites"} */}
                                    {/* <i className={`${myFavoritesUnitsOpen ? "las" : "lar"} la-heart fs-2hx text-dark`}></i> */}
                                </div>
                            </div>
                        </div>
                        : null
                    : Number(userID) === Number(REACT_APP_BSO_USER_ID)
                        ?
                        <div className='w-100 d-flex'>
                            <div className={`btn ${myArchivedUnitsOpen ? 'btn-bg-dark text-white' : 'btn-bg-light-secondary link-dark'} p-2 px-auto ms-4 border border-dark fw-bold fs-7 text-uppercase text-nowrap flex-fill d-inline-flex align-items-center justify-content-center gap-2`}
                                onClick={() => {
                                    dispatch(setMyArchivedUnitsOpen(!myArchivedUnitsOpen))
                                    dispatch(setMyRequestedUnitsOpen(false))
                                    dispatch(setMyPublishedUnitsOpen(false))
                                }}>
                                <span>ARCHIVE</span>
                                <span className={`badge badge-circle ${myArchivedUnitsOpen ? 'badge-light' : 'badge-dark'}`}>{archiveCount}</span>

                            </div>

                            {/* {Number(userID) === Number(REACT_APP_BSO_SUPPORT_USER_ID) &&
                                < span
                                    onClick={() => onClickCategory('')}
                                    className="col d-inline-block position-relative text-center cursor-pointer"
                                >
                                    <div className="d-inline-block link-dark fw-bold my-4">REQUESTED UNITS</div>
                                    <span
                                        className={`d-inline-block position-absolute h-4px bottom-0 end-0 start-0  translate rounded-top 
                                            ${filter.unitsCategory === '' ? 'bg-dark' : 'bg-light'}`}
                                    >
                                    </span>
                                </span>} */}

                            <div className={`btn ${myRequestedUnitsOpen ? 'btn-bg-dark text-white' : 'btn-bg-light-secondary link-dark'} p-2 px-auto ms-4 border border-dark fw-bold fs-7 text-uppercase text-nowrap flex-fill d-inline-flex align-items-center justify-content-center gap-2`}
                                onClick={() => {
                                    dispatch(setMyRequestedUnitsOpen(!myRequestedUnitsOpen))
                                    dispatch(setMyArchivedUnitsOpen(false))
                                    dispatch(setMyPublishedUnitsOpen(false))
                                }}>
                                <span>REQUESTED</span>
                                <span className={`badge badge-circle ${myRequestedUnitsOpen ? 'badge-light' : 'badge-dark'}`}>{requestedCount}</span>
                            </div>
                            <div className={`btn ${myPublishedUnitsOpen ? 'btn-bg-dark text-white' : 'btn-bg-light-secondary link-dark'} p-2 px-auto ms-4 border border-dark fw-bold fs-7 text-uppercase text-nowrap flex-fill d-inline-flex align-items-center justify-content-center gap-2`}
                                onClick={() => {
                                    dispatch(setMyPublishedUnitsOpen(!myPublishedUnitsOpen))
                                    dispatch(setPublishedVisibilityFilter('catalog'))
                                    dispatch(setMyRequestedUnitsOpen(false))
                                    dispatch(setMyArchivedUnitsOpen(false))
                                }}>
                                <span>OTHER UNITS</span>
                                <span className={`badge badge-circle ${myPublishedUnitsOpen ? 'badge-light' : 'badge-dark'}`}>{otherUnitsCount}</span>
                            </div>
                        </div>

                        : null
                }

            </div >
        </div >
    )
}
